import { combineReducers } from "redux";

import { bookingsAdminLocalReducer, initialState as bookingsLocalInitialState } from "./BookingsAdminLocalSlice"
import { commonReducerFor, initialState as commonInitialState } from "../../../Redux/CommonReducer";
import { bookingsAmenityFormReducer, initialState as bookingsAmenityFormInitialState } from "./BookingsAmenityFormSlice";


export const bookingsAdminSliceReducer = combineReducers({
    common: commonReducerFor('BOOKINGS'),
    local: bookingsAdminLocalReducer,
    amenityForm: bookingsAmenityFormReducer,
});

export const initialState = {
    common: commonInitialState,
    local: bookingsLocalInitialState,
    amenityForm: bookingsAmenityFormInitialState,
}
